import { api_GET, api_POST, api_PUT, api_DELETE, api_GET_Unauthorize } from "./_api.js";


const prefeitura_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize('Prefeitura/GetList')
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Prefeitura/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetImagensQrcode: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Prefeitura/GetImagensQrcode/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Insert: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST('Prefeitura', obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Update: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT('Prefeitura', obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetTermoCadastroGerador: (prefeituraId) => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Prefeitura/GetTermoCadastroGerador/${prefeituraId}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    }
}
export default prefeitura_api;